/**
 * Install-target values shared by the landing "Get the app" section and the
 * dedicated /android-install page, so the two cannot drift apart.
 *
 * The APK location is read once at module scope. Tests that need a different
 * value have to re-import the module (vi.resetModules) rather than re-render,
 * which is why this lives in its own module instead of being inlined twice.
 */

/**
 * Set at build time from the ANDROID_APK_URL repository variable - see
 * docs/operations/ANDROID_APK.md. Undefined until an APK is published, and the
 * empty-string default of the Docker build arg is deliberately falsy so an
 * unconfigured deploy renders the "not available yet" state rather than a link
 * to nowhere.
 */
export const APK_URL = import.meta.env["VITE_ANDROID_APK_URL"] as
  | string
  | undefined;

/** The site's own URL, for the QR a phone camera scans to open it. */
export function siteUrl(): string {
  if (typeof window === "undefined") return "https://travelhealthpass.app";
  return window.location.origin;
}

/**
 * Absolute URL of the Android install page. Absolute rather than the "/android-install"
 * path because it is encoded into a QR code, which has no page to be relative to.
 */
export function androidInstallUrl(): string {
  return `${siteUrl()}/android-install`;
}
